import Vue from 'vue'
import moment from 'moment-timezone'
import { Tooltip } from 'ant-design-vue'

Vue.use(Tooltip)

export default Vue.extend({
  template: `
      <span style="display: block;">
        <a-tooltip placement="right" :title="value">
          {{ value }}
        </a-tooltip>
      </span>`,
  data: function() {
    return {
      value: '',
      dateFormat: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.dateFormat = settings
    if (this.params.type === 'projectDetails' && this.params.value) {
      const splitDate = this.params.value.split('/')
      if (splitDate.length === 1) {
        this.value = this.params.value
      } else if (splitDate.length === 2) {
        this.value = this.params.value
      } else {
        this.value = moment(new Date(this.params.value)).format(
          this.dateFormat['datetime'].dateFormat,
        )
      }
    } else {
      if (this.params.value) {
        this.value = moment
          .utc(this.params.value)
          .tz(moment.tz.guess())
          .format(this.dateFormat['datetime'].dateTimeFormat)
      }
    }
  },
})
